
import {finalize} from 'rxjs/operators';
// angular
import { ActivatedRoute, Router } from '@angular/router';
import {Component, OnInit, ViewChildren, QueryList, ElementRef, Inject, OnDestroy} from '@angular/core';
import {DOCUMENT, Location} from '@angular/common';
import { FeelingsRatingService } from './feelings-rating.service';
import { FeelingComponent } from './feeling/feeling.component';
import { AppService } from '../../app.service';
import { SelfEvaluationService } from '../self-evaluation.service';
import set = Reflect.set;
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SelectionComponent } from '../selection.component';
import { CoreService } from '../../core/core.service';
import { AuthService } from '../../core/auth.service';

// services

// others
declare var window: any;

@Component({
    selector: 'feelings-rating-component',
    templateUrl: './feelings-rating.component.html',
    styleUrls: ['./feelings-rating.component.scss', '../self-evaluation.component.scss'],
    providers: [FeelingsRatingService]
})
export class FeelingsRatingComponent extends SelectionComponent implements OnInit, OnDestroy {
    questionnaireId: any;
    startTime: any;
    isMobile = false;
    dbFeelings: Array<Object> = [];
    feelings: Array<Object> = [];
    @ViewChildren(FeelingComponent) feelingComps: QueryList<FeelingComponent>;
    feelingGroups = [];
    activePage = 1;
    nextFeelingIndex = 0;
    totalFeelings = 0;
    markedFeelings : Array<Object> = [];

    currentId: number;
    offsetX: number;
    offsetY: number;
    zIndex = 20;
    symptomWidth = 280;
    symptomHeight = 65;
    ratingAreaPadding = 32;
    symptomSpacingInit = 36;
    symptomPositionLeftInit = 0;
    symptomScaleOnMobile = 1;
    nextIsAllowed = false;
    totalRatingsOnAPage = [];
    token: string;
    isStudy = false;
    nextStep = false;
    handleHash: any;
    currentStep : number;
    itemPerPage : number = 12;
    ratingStep: number;
    mouseEvent = {
        nothing: 0,
        mousedown: 1,
        mousemove: 2,
        mouseup: 3
    };
    currentEvent = 0;
    isIOS = false;
    btnPosition = 0;
    deviceInnerHeight: number;
    lang = 'de_CH';
    subscription: Subscription;
    maxRatingBar = 562;
    echo: any;
    haveAnamnestic = true;

    get isLoading() {
        return this.appService.isLoading;
    }

    set isLoading(isLoading) {
        this.appService.isLoading = isLoading;
    }

    constructor(
        public elementRef: ElementRef,
        public service: SelfEvaluationService,
        public feelingsRatingService: FeelingsRatingService,
        public route: ActivatedRoute,
        public authService: AuthService,
        public router: Router,
        public location: Location,
        public appService: AppService,
        public coreService: CoreService,
        public translateService: TranslateService,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(elementRef, service, router, route, authService, appService, coreService, translateService);
    }

    ngOnInit() {
        this.isLoading = true;
        this.lang = this.translateService.currentLang;
        this.noBackPlease();
        window.onbeforeunload = this.popupReload;
        window.onkeydown = this.preventBack;

        this.startTime = new Date();
        this.ratingStep = (this.appService.SEType === this.pageTypes.se.type) ? this.appService.steps.FEELING_RATING : this.appService.repeatSteps.FEELING_RATING;
        this.appService.setCurrentSeStep(this.ratingStep);
        this.setSEType();

        this.isMobile = this.appService.isMobile;
        this.isIOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        this.deviceInnerHeight = window.innerHeight;
        this.maxRatingBar = (this.deviceInnerHeight - 168) > this.maxRatingBar ? this.maxRatingBar : (this.deviceInnerHeight - 168);

        // calculate spacing between each symptoms always inner rating bar
        // 60px is padding top and bottom
        this.symptomSpacingInit = Math.round((this.maxRatingBar - this.symptomHeight - 60)/11);
        if( this.isMobile){
            this.symptomScaleOnMobile = 0.85;
            this.symptomSpacingInit = 4;
            this.itemPerPage = 6;
            this.symptomWidth = window.screen.width - 32;
            /**
             * padding top + bottom : 64px
             * button height : 106px
             * Progress Bar : 75px
             */
        }
        if(this.isIOS){
            this.document.body.classList.add("iOS");
        }


        this.route.params.subscribe(params => {
            this.token = params.token;
            this.feelingsRatingService.getItems(this.token, this.itemPerPage)
                .subscribe(
                response => {
                    // if no feelings were selected in the last step, go straight to the next one
                    if (response['items'].length === 0) {
                        this.nextIsAllowed = true;
                        this.goToNext();
                        return;
                    }
                    this.dbFeelings = response['items'].filter(f => f['is_selected_by_patient']);
                    // check if the questionnaire step is FEELING RATING. Otherwise, go to its step
                    if (response['questionnaire_step'] !== this.ratingStep) {
                        this.navigateToStep(response['questionnaire_step']);
                    } else {
                        this.activePage = response['active_page'] ? response['active_page'] : 1;
                        this.nextFeelingIndex = response['next_item_index'] ? response['next_item_index'] : 1;
                        this.totalFeelings = response['total_item'];

                        this.initFeelingBoxes();
                        if(this.isMobile){
                            this.btnPosition = this.elementRef.nativeElement.querySelector('.wrapper__btns').offsetTop;
                        }
                    }
                    this.isStudy = response['is_study'];
                    this.questionnaireId = response['patient_questionnaire_id'];
                    this.currentStep  = response['questionnaire_step'];

                    this.haveAnamnestic = response['is_have_ananmestic_step'];

                    //2157
                    this.echo = this.appService.initEcho();
                    const self = this;
                    this.echo.channel('Questionnaire.' + this.questionnaireId).listen('InactivePatient', function (data) {
                        self.router.navigate([ self.pageTypes[self.type]['route'] + '/' + self.token]);
                    });
                    this.isLoading = false;
                }
                );
        });

        this.subscription = this.translateService.onLangChange.subscribe(value => {
            this.lang = value.lang;
            let data = {
                'questionnaire_id' : this.questionnaireId,
                'language' : value.lang
            };

            this.isLoading = true;
            this.service.changeLanguage(data).subscribe(language => {
                this.isLoading = false;
            });
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    navigateToStep(step) {
        let currentPath = this.location.path().split('/');
        if (step) {
            return this.router.navigate([currentPath[1] + '/' + currentPath[2] + step]);
        }
        return this.router.navigate([currentPath[1] + '/' + currentPath[2]]);
    }

    scrollToTop() {
        let scrollStep = -window.scrollY / (500 / 15),
            scrollInterval = setInterval(function(){
                if ( window.scrollY != 0 ) {
                    window.scrollBy( 0, scrollStep );
                }
                else clearInterval(scrollInterval);
            },15);

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        document.getElementById("top-el").scrollIntoView();
        setTimeout(function(){
            this.deviceInnerHeight = window.innerHeight;
        }, 200);
    }

    initFeelingBoxes() {
        this.nextIsAllowed = false;
        this.scrollToTop();
        this.totalRatingsOnAPage = [];

        if (this.feelingGroups != null) {
            this.feelingGroups = [];
        }
        if (this.feelings != null) {
            this.feelings = [];
        }

        // largest possible number of feeling boxes on each page
        let numOfBoxes = [];
        // the points at which the feelings boxes get slpit into halves on each page
        let starts = [0];
        let boxesOnLastPages = 0;
        let num = 1;
        let maxBoxes = this.itemPerPage;
        while (true) {
            numOfBoxes.push(maxBoxes);
            this.feelingGroups.push(num);
            num++;
            boxesOnLastPages += maxBoxes;
            if (boxesOnLastPages >= this.dbFeelings.length) {
                break;
            }
        }

        for (let k = 0; k < numOfBoxes.length; k++) {
            starts.push(starts[k] + numOfBoxes[k]);
        }

        let ratingAreaRight = this.elementRef.nativeElement.querySelector('.rating-area').offsetWidth;
        let ratingAreaPosLeft = this.elementRef.nativeElement.querySelector('.rating-area').offsetLeft;
        let ratingAreaPosTop = this.elementRef.nativeElement.querySelector('.rating-area').offsetTop;
        let ratingScaleBottom = this.elementRef.nativeElement.querySelector('.rating-scale').offsetTop
            + this.elementRef.nativeElement.querySelector('.rating-scale').offsetHeight;

        this.symptomPositionLeftInit = ratingAreaRight - this.symptomWidth - ratingAreaPosLeft + 20;
        let startingY = this.isMobile ? (this.elementRef.nativeElement.querySelector('.wrapper__btns').offsetTop -  ratingAreaPosTop) : ratingScaleBottom - this.symptomHeight;

        let i = starts[this.activePage - 1];
        for (let j = 0; i < starts[this.activePage]; i++ , j++) {
            let topBoxId = -1;
            let bottomBoxId = -1;
            if (this.dbFeelings[i] != null) {
                let x = this.isMobile ? 16 : this.symptomPositionLeftInit;
                let y = 0;

                y = startingY - this.symptomSpacingInit * j;
                topBoxId = j + 1;
                bottomBoxId = j - 1;

                this.feelings.push({
                    index: j,
                    id: this.dbFeelings[i]['id'],
                    x: this.isMobile ? (x + this.symptomSpacingInit * j) : x,
                    y: y,
                    originalX: x,
                    originalY: y,
                    width: this.isMobile ? (this.symptomWidth - (2 * this.symptomSpacingInit * j)) : this.symptomWidth,
                    height: this.symptomHeight,
                    'z-index': this.activePage * 12 - i,
                    connectionX: null,
                    connectionWidth: null,
                    topBoxId: topBoxId,
                    bottomBoxId: bottomBoxId,
                    isDragged: false,
                    dropped: false,
                    disabled: false,
                    description_de_CH: this.dbFeelings[i]['feeling']['statement_de_CH'],
                    description_en_GB: this.dbFeelings[i]['feeling']['statement_en_GB']
                });
            }
        }
        if(!this.isMobile){
            return;
        }
        // Generate Highest & Lowest only on mobile
        if(this.markedFeelings['max']){
            const highestItem = this.markedFeelings['max'];
            this.feelings.push(highestItem);
            this.totalRatingsOnAPage.push('max');
        }
        if(this.markedFeelings['min']){
            const lowestItem = this.markedFeelings['min'];
            this.feelings.push(lowestItem);
            this.totalRatingsOnAPage.push('min');
        }
    }

    mouseDown(event) {
        if(this.currentEvent == this.mouseEvent.mouseup){
            return false;
        }
        if (event.target.getAttribute('dataId') != null) {
            this.currentEvent = this.mouseEvent.mousedown;
            let id = Number(event.target.getAttribute('dataId'));
            this.currentId = id;

            // reset the z-index so that it will never be high and the z-index of each droppped box will be higher
            // than those that have not been dropped & the dropped box that's being dragged will have the highest z-index
            this.zIndex = this.feelingGroups.length * 12;
            this.feelingComps.forEach(feeling => {
                if (feeling['feeling']['dropped']) {
                    feeling['feeling']['z-index'] = this.zIndex;
                    this.zIndex +=2;
                }
            });

            let BreakException = {};
            try {
                this.feelingComps.forEach((item, index, feelings) => {
                    if (event.clientX != null && event.clientY != null) {
                        this.offsetX = feelings[this.currentId]['feeling']['x'] - event.clientX;
                        this.offsetY = feelings[this.currentId]['feeling']['y'] - event.clientY;
                    } else if (event.touches[0].clientX != null && event.touches[0].clientY != null) {
                        this.offsetX = feelings[this.currentId]['feeling']['x'] - event.touches[0].clientX;
                        this.offsetY = feelings[this.currentId]['feeling']['y'] - event.touches[0].clientY;
                    }

                    feelings[this.currentId]['feeling']['connectionWidth'] = null;
                    feelings[this.currentId]['feeling']['dropping'] = true;
                    feelings[this.currentId]['feeling']['z-index'] = this.zIndex;
                    feelings[this.currentId]['feeling']['connection-index'] = this.zIndex;

                    throw BreakException;
                });
            } catch (e) {
                if (e !== BreakException) {
                    throw e;
                }
            }
        }
    }

    mouseMove(event) {
        if (this.currentId != null) {
            event.preventDefault();
            this.currentEvent = this.mouseEvent.mousemove;

            let BreakException = {};
            let ratingOffsetTop = this.elementRef.nativeElement.querySelector('.rating-scale').offsetTop;
            let ratingOffsetBottom = ratingOffsetTop + this.elementRef.nativeElement.querySelector('.rating-scale').offsetHeight;
            try {
                this.feelingComps.forEach((item, index, feelings) => {
                    if (event.clientX != null && event.clientY != null) {
                        feelings[this.currentId]['feeling']['x'] = event.clientX + this.offsetX;
                        feelings[this.currentId]['feeling']['y'] = event.clientY + this.offsetY;
                    } else if (event.touches[0].clientX != null && event.touches[0].clientY != null) {
                        feelings[this.currentId]['feeling']['x'] = event.touches[0].clientX + this.offsetX;
                        feelings[this.currentId]['feeling']['y'] = event.touches[0].clientY + this.offsetY;
                    }

                    // calculate the x coordinate & the width of the connections to display
                    feelings[this.currentId]['feeling']['connectionX'] = this.elementRef.nativeElement.querySelector('.rating-scale').offsetLeft;
                    feelings[this.currentId]['feeling']['connectionWidth']
                        = feelings[this.currentId]['feeling']['x'] - this.elementRef.nativeElement.querySelector('.rating-scale').offsetLeft;

                    feelings[this.currentId]['feeling']['dropping'] = true;
                    feelings[this.currentId]['feeling']['dropped'] = false;

                    if((feelings[this.currentId]['feeling']['y'] + feelings[this.currentId]['feeling']['height'] / 2) < ratingOffsetTop ||
                        (feelings[this.currentId]['feeling']['y'] + feelings[this.currentId]['feeling']['height'] / 2) > ratingOffsetBottom ||
                        feelings[this.currentId]['feeling']['x'] < this.elementRef.nativeElement.querySelector('.rating-scale').offsetLeft
                    ){
                        feelings[this.currentId]['feeling']['connection-index'] = -1;
                        feelings[this.currentId]['feeling']['connectionWidth'] = 0;
                    }
                    else{
                        feelings[this.currentId]['feeling']['connection-index'] = feelings[this.currentId]['feeling']['z-index'];
                    }

                    if (!feelings[this.currentId]['feeling']['isDragged']
                        && feelings[this.currentId]['feeling']['x'] !== feelings[this.currentId]['feeling']['originalX']
                        && feelings[this.currentId]['feeling']['y'] !== feelings[this.currentId]['feeling']['originalY']) {
                        feelings[this.currentId]['feeling']['isDragged'] = true;
                        let selectedFeeling = feelings[this.currentId];
                        setTimeout(() => {
                            while (selectedFeeling['feeling']['topBoxId'] !== -1
                                && feelings[selectedFeeling['feeling']['topBoxId']]
                                && !feelings[selectedFeeling['feeling']['topBoxId']]['feeling']['dropped']) {
                                feelings[selectedFeeling['feeling']['topBoxId']]['feeling']['y'] += this.symptomSpacingInit;
                                if(this.isMobile){
                                    feelings[selectedFeeling['feeling']['topBoxId']]['feeling']['width'] += (2 * this.symptomSpacingInit);
                                    feelings[selectedFeeling['feeling']['topBoxId']]['feeling']['x'] -= this.symptomSpacingInit;
                                }

                                // update the top box id of the box under the dragged box
                                if (selectedFeeling['feeling']['bottomBoxId'] !== -1
                                    && selectedFeeling['feeling']['isDragged']) {
                                    feelings[selectedFeeling['feeling']['bottomBoxId']]['feeling']['topBoxId']
                                        = selectedFeeling['feeling']['topBoxId'];
                                    // update the bottom box id of the top box
                                    feelings[selectedFeeling['feeling']['topBoxId']]['feeling']['bottomBoxId']
                                        = selectedFeeling['feeling']['bottomBoxId'];
                                }

                                // get the top box of the dragged box and repeat the process
                                selectedFeeling = feelings[selectedFeeling['feeling']['topBoxId']];
                            }
                        }, 200);

                    }

                    throw BreakException;
                });
            } catch (e) {
                if (e !== BreakException) {
                    throw e;
                }
            }
        }
    }

    mouseUp(event) {
        if (this.currentId != null) {
            this.currentEvent = this.mouseEvent.mouseup;
            let BreakException = {};
            try {
                this.feelingComps.forEach((item, index, feelings) => {
                    let ratingScaleLeft = this.elementRef.nativeElement.querySelector('.rating-scale').offsetLeft;
                    let ratingScaleRight = this.elementRef.nativeElement.querySelector('.rating-scale').offsetLeft
                        + this.elementRef.nativeElement.querySelector('.rating-scale').offsetWidth;
                    let ratingScaleTop = this.elementRef.nativeElement.querySelector('.rating-scale').offsetTop;
                    let ratingScaleBottom = this.elementRef.nativeElement.querySelector('.rating-scale').offsetTop
                        + this.elementRef.nativeElement.querySelector('.rating-scale').offsetHeight;

                    // ensure the feeling boxes are not dragged out of the rating area
                    let ratingAreaTop = 0;
                    let ratingAreaBottom = this.elementRef.nativeElement.querySelector('.rating-area').offsetHeight;
                    let ratingAreaLeft = 0;
                    let ratingAreaRight = this.elementRef.nativeElement.querySelector('.rating-area').offsetWidth;
                    if (feelings[this.currentId]['feeling']['x'] < ratingAreaLeft) {
                        feelings[this.currentId]['feeling']['x'] = ratingAreaLeft + this.ratingAreaPadding;
                    } else if (feelings[this.currentId]['feeling']['x'] + feelings[this.currentId]['feeling']['width'] > ratingAreaRight) {
                        feelings[this.currentId]['feeling']['x'] = ratingAreaRight - this.ratingAreaPadding
                            - feelings[this.currentId]['feeling']['width'];
                    }
                    if (feelings[this.currentId]['feeling']['y'] < ratingAreaTop) {
                        feelings[this.currentId]['feeling']['y'] = ratingAreaTop;
                    } else if (feelings[this.currentId]['feeling']['y'] + feelings[this.currentId]['feeling']['height']/2 > ratingAreaBottom) {
                            feelings[this.currentId]['feeling']['y'] = ratingScaleBottom - feelings[this.currentId]['feeling']['height'] / 2 - 1;
                    }

                    if(feelings[this.currentId]['feeling']['x'] > (this.symptomPositionLeftInit - this.symptomWidth)){
                        feelings[this.currentId]['feeling']['x'] = this.symptomPositionLeftInit - this.symptomWidth - 20;
                    }

                    // drop the feeling boxes right onto the top / bottom of the rating scale after they're dropped just over/ under it
                    if (feelings[this.currentId]['feeling']['y'] + feelings[this.currentId]['feeling']['height'] / 2 < ratingScaleTop) {
                        feelings[this.currentId]['feeling']['y'] = ratingScaleTop - feelings[this.currentId]['feeling']['height'] / 2;
                    } else if (feelings[this.currentId]['feeling']['y'] + feelings[this.currentId]['feeling']['height'] / 2 > ratingScaleBottom) {
                        feelings[this.currentId]['feeling']['y'] = ratingScaleBottom - feelings[this.currentId]['feeling']['height'] / 2 - 1;
                    }

                    // if the feeling boxes have been dragged within the rating scale
                    if (feelings[this.currentId]['feeling']['y'] + feelings[this.currentId]['feeling']['height'] / 2 >= ratingScaleTop
                        && feelings[this.currentId]['feeling']['y']
                        + feelings[this.currentId]['feeling']['height'] / 2 <= ratingScaleBottom) {

                        // ensure the feeling boxes are not dragged over the rating scale
                        let offset = 40;
                        if (feelings[this.currentId]['feeling']['x'] <= (ratingScaleLeft + offset)
                            && feelings[this.currentId]['feeling']['x'] + feelings[this.currentId]['feeling']['width'] / 2 <= ratingScaleLeft)
                        {
                            feelings[this.currentId]['feeling']['x'] = ratingScaleLeft + offset;
                        } else if (feelings[this.currentId]['feeling']['x'] <= ratingScaleRight + offset
                            && feelings[this.currentId]['feeling']['x'] + feelings[this.currentId]['feeling']['width'] / 2 >= ratingScaleLeft) {
                            feelings[this.currentId]['feeling']['x'] = ratingScaleRight;
                        }

                        // check if all feelings have been rated to enable to next button
                        feelings[this.currentId]['feeling']['dropping'] = false;
                        if (!feelings[this.currentId]['feeling']['dropped']) {
                            feelings[this.currentId]['feeling']['dropped'] = true;
                            if(this.totalRatingsOnAPage.indexOf(this.currentId) === -1){
                                this.totalRatingsOnAPage.push(this.currentId);
                                if (this.totalRatingsOnAPage.length === this.feelings.length) {
                                    this.nextIsAllowed = true;
                                }
                            }
                        }

                        // calculate & store the rating
                        let ratingScaleHeight = this.elementRef.nativeElement.querySelector('.rating-scale').offsetHeight;
                        let relativeToScaleY = (feelings[this.currentId]['feeling']['y'] - (ratingScaleTop - ratingAreaTop - feelings[this.currentId]['feeling']['height'] / 2)) / (ratingScaleHeight / 98);
                        feelings[this.currentId]['feeling']['connection-index'] = 1;

                        for (let dbFeeling of this.dbFeelings) {
                            if (dbFeeling['id'] === feelings[this.currentId]['feeling']['id']) {
                                let rating = Math.floor(98 - relativeToScaleY);
                                if (rating === 0 || rating === 1) {
                                    dbFeeling['rating_by_patient'] = 2;
                                } else {
                                    dbFeeling['rating_by_patient'] = rating;
                                }
                                break;
                            }
                        }
                    }

                    // calculate the x coordinate & the width of the connections to display
                    feelings[this.currentId]['feeling']['width'] = this.symptomWidth;
                    if(this.isMobile){
                        feelings[this.currentId]['feeling']['x'] = (ratingAreaRight - this.elementRef.nativeElement.querySelector('.rating-scale').offsetWidth - feelings[this.currentId]['feeling']['width'] * this.symptomScaleOnMobile)/2;
                    }
                    feelings[this.currentId]['feeling']['connectionX'] = ratingScaleLeft;
                    feelings[this.currentId]['feeling']['connectionWidth'] = feelings[this.currentId]['feeling']['x'] - feelings[this.currentId]['feeling']['connectionX'] + (this.symptomWidth/2)*(1- this.symptomScaleOnMobile);

                    this.currentId = null;
                    throw BreakException;
                });
            } catch (e) {
                setTimeout(() => {
                    this.currentEvent = this.mouseEvent.nothing;
                },200);
                if (e !== BreakException) {
                    throw e;
                }
            }
        }
    }

    goToNext() {
        if(this.currentEvent != this.mouseEvent.nothing){
            return false;
        }
        if (this.nextIsAllowed) {
            this.isLoading = true;

            // Get HIGHEST and LOWEST symptoms on Mobile
            if(this.isMobile){
                this.feelingComps.forEach((item, index, feelings) => {
                    if(!this.markedFeelings['max'] || this.markedFeelings['max']['y'] <= item['feeling']['y']){
                        this.markedFeelings['max'] = _.cloneDeep(item['feeling']);
                        this.markedFeelings['max']['disabled'] = true;
                        this.markedFeelings['max']['id'] = null;
                        this.markedFeelings['max']['z-index'] = 1;
                        this.markedFeelings['max']['isDragged'] = true;
                        this.markedFeelings['max']['dropped'] = true;

                    }
                    if(!this.markedFeelings['min'] || this.markedFeelings['min']['y'] >= item['feeling']['y']){
                        this.markedFeelings['min'] = _.cloneDeep(item['feeling']);
                        this.markedFeelings['min']['id'] = null;
                        this.markedFeelings['min']['disabled'] = true;
                        this.markedFeelings['min']['z-index'] = 1;
                        this.markedFeelings['min']['isDragged'] = true;
                        this.markedFeelings['min']['dropped'] = true;
                    }
                });
            }

            if (this.activePage < this.feelingGroups.length) {
                this.activePage++;
                this.feelingsRatingService.submit(this.token, this.dbFeelings, this.activePage, this.itemPerPage).pipe(
                    finalize(() => {
                        this.isLoading = false;
                    }))
                    .subscribe(
                        response => {
                            if (response['success']) {
                                this.nextFeelingIndex = response['next_item_index'];
                                this.initFeelingBoxes();
                            }
                        }
                    );
            } else {
                this.allowBack();
                this.feelingsRatingService.submit(this.token, this.dbFeelings, 0).pipe(
                    finalize(() => {
                        this.isLoading = false;
                    }))
                    .subscribe(
                        response => {
                            if (response['success']) {
                                this.nextStep = true;
                                if (!this.haveAnamnestic) {
                                    this.service.isRedirectedFromAmnestic = true;
                                }
                                this.navigateToStep(0);
                            }
                        }
                    );
            }
        }

        this.saveCountTime();
    }

    continueLater() {
        this.router.navigate([this.pageTypes[this.appService.SEType]['route'] + '/' + this.token + '/continue-later']);
    }
}
